import moment from "moment"
import { IDropdownOption } from "~/components/ui/DropdownSelector/interfaces/DropdownOption"

export const getDayOptions = (month: number): IDropdownOption[] => [
  { value: null, label: "" },
  ...new Array(
    moment()
      .month(month - 1)
      .daysInMonth(),
  )
    .fill(0)
    .map((day, key) => ({
      value: (key + 1).toString(),
      label: (key + 1).toString(),
    })),
]
